import { createTheme } from "@mui/material";

const BaseTheme = createTheme({
    typography: {
        fontFamily: "Poppins, sans-serif",
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                    minWidth: 120,
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                h1: {
                    fontSize: "1rem",
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "& input[type='number']": {
                        // Hide the spinner controls in WebKit-based browsers
                        "&::-webkit-inner-spin-button": {
                            display: "none",
                            WebkitAppearance: "none",
                        },
                        "&::-webkit-outer-spin-button": {
                            display: "none",
                            WebkitAppearance: "none",
                        },
                        // Hide the spinner controls in Firefox
                        MozAppearance: "textfield",
                    },
                },
            },
        },
    },
});

export default BaseTheme;
